import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import viewOrComment from '../components/viewOrComment.vue'

const __default__ = {
  name: 'DcCosOFbuFollowUpRecordView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(viewOrComment, { type: "view" }))
}
}

})